// How a session's time is worded to a client, in one place.
//
// It lived inside `SessionCard.tsx` and was private to it, which was fine while
// that card was the only thing that said a session time to a couple. It is not
// any more: couple onboarding's Homebase renders the session in `SlotSummaryCard`
// (the same card the therapist confirmed the booking on) and needs this wording
// without that card's markup.
//
// ITS OWN MODULE rather than an export added to the component file. Exporting a
// function beside a component breaks Fast Refresh, and `react-refresh/only-export-
// components` fails the build on it — correctly, and its advice is exactly this:
// "use a new file to share constants or functions between components".

/**
 * "Wednesday, September 10 at 9:00 AM", in the viewer's locale.
 *
 * Invalid or empty input falls back to the raw string rather than rendering
 * "Invalid Date": a session card showing a stray ISO timestamp is a bug someone
 * reports, where one showing "Invalid Date" is a bug they screenshot.
 */
export function formatSessionTime(iso: string): string {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
        return iso;
    }
    const day = d.toLocaleDateString(undefined, {
        weekday: "long",
        month: "long",
        day: "numeric",
    });
    const time = d.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });
    return `${day} at ${time}`;
}
